import { HttpService } from '@ribajs/core'
import { Pjax } from '@ribajs/router'

/**
 * @see https://shopify.dev/api/section-rendering
 */
export class ShopifySectionService {
  static root = window.Shopify?.routes?.root || '/'

  /**
   * Get sections using the Shopify Section API
   * @param ids
   * @param href
   * @returns
   */
  static async getSections(ids: string[], contextUrl?: string) {
    contextUrl ||= `${window.location.protocol}//${window.location.host}${this.root}`
    const url = new URL(contextUrl, window.location.origin)

    for (const id of ids) {
      url.searchParams.append('sections', id)
    }

    const res = await HttpService.getJSON(url.href)
    return res.body
  }

  /**
   * Get section using the Shopify Section API
   * @param id
   * @param contextUrl
   * @returns
   */
  static async getSection(id: string, contextUrl?: string) {
    contextUrl ||= `${window.location.protocol}//${window.location.host}${this.root}`
    const url = new URL(contextUrl, window.location.origin)

    url.searchParams.append('section_id', id)

    const res = await HttpService.get(url.href)
    return res.body as string
  }

  static excludeSectionsByIdAffixes(
    sections: HTMLElement[],
    excludeIdAffixes: string[] = [],
  ) {
    return sections.filter(section => {
      const id = section.getAttribute('id')
      if (!id) {
        return false
      }
      for (const excludeIdAffix of excludeIdAffixes) {
        if (id.endsWith(excludeIdAffix)) {
          return false
        }
      }
      return true
    })
  }

  /**
   * Get sections from page by url.
   *
   * WARNING: This method is slow, because it loads the whole page and parses the sections from the HTML.
   *
   * @param url The url of the page
   * @param excludeIdAffixes Exclude sections with id affixes
   * @returns An array of HTMLElements with the sections of the page in the '#main-container' element
   */
  static async getSectionsFromPageRequest(
    url: string,
    excludeIdAffixes: string[] = [],
  ) {
    const pjax = Pjax.getInstance()
    if (!pjax) {
      throw new Error('Pjax is not initialized!')
    }
    const res = await (
      await pjax.loadResponseCached(url, false, false)
    ).responsePromise

    if (!res.container) {
      throw new Error('No container found!')
    }

    const sections = this.excludeSectionsByIdAffixes(
      Array.from(res.container.querySelectorAll('.shopify-section.section')),
      excludeIdAffixes,
    )

    return sections
  }
}
